import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { DeviceForm } from '@/features/admin/devices/components/device-form'
import { useCreateAdminDevice } from '@/features/admin/devices/hooks/use-create-admin-device'
import { AdminPageHeader } from '@/features/admin/layout/admin-page-header'
import { router } from '@/router'

export const Route = createFileRoute('/admin/devices/create')({
  component: AdminDeviceCreatePage,
})

function AdminDeviceCreatePage() {
  const { t } = useTranslation('admin')
  const { mutate, isPending } = useCreateAdminDevice()

  return (
    <div className="space-y-4">
      <AdminPageHeader
        title={t('devices.create.title')}
        subtitle={t('devices.create.subtitle')}
      />
      <div className="mx-auto max-w-3xl">
        <DeviceForm
          isSubmitting={isPending}
          onSubmit={(data) => mutate(data)}
          onCancel={() => router.navigate({ to: '/admin/devices' })}
          submitLabel={t('devices.create.submit')}
        />
      </div>
    </div>
  )
}
